import PaperButton from "components/buttons/PaperButton";
import CustomTable from "components/CustomTable";
import StatusBadge from "components/StatusBadge";
import moment from "moment";
import React from "react";

export default function StaffTable({
  data = [],
  onDelete = () => {},
  onEdit = () => {},
}) {
  return (
    <div className="py-5">
      <CustomTable
        data={data}
        columns={[
          { label: "Name", selector: "name" },
          {
            label: "Email",
            selector: "email",
            cell: (row) => row?.email,
          },
          {
            label: "Permissions",
            selector: "role",
            cell: (row) => (row?.role === "2" ? "Admin" : "Packer"),
          },
          {
            label: "Date Added",
            selector: "created_at",
            sortValue: (row) => moment(row?.created_at).unix(),
            cell: (row) => moment(row?.created_at).format("DD MMMM, YYYY"),
          },
          {
            label: "Status",
            selector: "status",
            cell: (row) => (
              <div className="flex items-center">
                <StatusBadge
                  size="body2"
                  variant={
                    row?.status === "1"
                      ? "active"
                      : (row?.status ?? "0") === "0"
                      ? "disabled"
                      : "pending"
                  }
                />
              </div>
            ),
          },
          {
            label: "",
            selector: "actions",
            cell: (row, index) => (
              <div className="flex items-center">
                {/* <Button
                  variant="outlined"
                  size="small"
                  startIcon={<EditIcon />}
                  onClick={() => onEdit(row, index)}
                >
                  Edit
                </Button>
                <Button
                  className="mx-1"
                  variant="outlined"
                  size="small"
                  color="error"
                  startIcon={<DeleteIcon />}
                  onClick={() => onDelete(row, index)}
                >
                  Delete
                </Button> */}
                <div className="flex items-center">
                  <PaperButton
                    onClick={() => onEdit(row, index)}
                    variant="text"
                    color="primary"
                  >
                    View
                  </PaperButton>
                  <PaperButton
                    onClick={() => onDelete(row, index)}
                    variant="text"
                    color="error"
                  >
                    Delete
                  </PaperButton>
                </div>
              </div>
            ),
          },
        ]}
      />
    </div>
  );
}
